export const SET_IS_LOGIN_POPUP_OPEN = 'SET_IS_LOGIN_POPUP_OPEN';
export const LOGIN = 'LOGIN';
export const SET_LOGIN_REDIRECT_URL = 'SET_LOGIN_REDIRECT_URL';